import { render } from "./ListDelivered.vue?vue&type=template&id=d35422a2"
import script from "./ListDelivered.vue?vue&type=script&lang=js"
export * from "./ListDelivered.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__